import firebase from "../firebase";

export default function({ officeId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "getCurbsideTracking",
        data: { officeId }
    });
}
